import { ReactNode, useMemo } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import classNames from 'classnames';
import { ChevronDown } from 'tabler-icons-react';

import { useToggle } from 'hooks';

import styles from './OptionsDropdown.module.css';

export type OptionsDropdownOption = {
   value: string;
   label: string;
   rightComponent?: ReactNode;
   onClick: (value: string) => void;
};

type Props = {
   options: OptionsDropdownOption[];
   component: ReactNode;
};

export const OptionsDropdown = ({ options, component }: Props) => {
   const [isOpened, open, close] = useToggle(false);

   const renderOptions = useMemo(() => {
      return options.map(({ value, label, onClick, rightComponent }) => {
         const _onClick = () => {
            onClick(value);
            close();
         };

         return (
            <div key={value} onClick={_onClick} className={styles.expandedContainerItem}>
               <span>{label}</span>
               {rightComponent}
            </div>
         );
      });
   }, [close, options]);

   return (
      <OutsideClickHandler onOutsideClick={close}>
         <div className={styles.dropdownContainer}>
            <div
               onClick={open}
               className={classNames(styles.dropdownInnerContainer, {
                  [styles.innerContainerActive]: isOpened,
               })}
            >
               <div className={styles.component}>{component}</div>
               <ChevronDown className={styles.desktopOnly} />
            </div>

            <div className={classNames(styles.expandedContainer, { [styles.active]: isOpened })}>
               {renderOptions}
            </div>
         </div>
      </OutsideClickHandler>
   );
};
